export const user = ({ user }) => user
export const userIsEmployee = ({ user }) => user.last_tenant_id !== user.id
export const userIsCompany = ({ user }) => user.type === 'company'
export const userIsProfessional = ({ user }) => user.type === 'professional'
export const userIsProfessionalOrCompany = ({ user }) => user.type === 'professional' || user.type === 'company'



// WEBPACK FOOTER //
// ./src/store/getters/user.js